import React from 'react';
import { Link } from 'react-router-dom';

export default function GetStarted(props) {

    const text1 = props.text1 || '';
    const text2 = props.text2 || '';
    const text3 = props.text3 || '';
    const button = props.button || '';
    const buttonLink = props.buttonLink || '';
    const imagePath = props.imagePath || '';

    return (
        <>
        <div className='get-start-main-con container'>
           <div className="px-3 px-md-5 row g-0">
                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-sm-none">
                    <div className='bg-grad-purple text-center get-start-img'>
                        <img src={imagePath} alt="get-started-lurantech" />
                    </div>
                </div>
                <div  className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <div className='get-start-container'>
                        <div className='head-text black'>{text1}</div>
                        <div className='head-text grad-purple'>{text2}</div>
                        <div className='head-text black'>{text3}</div>
                        {buttonLink && <Link to={buttonLink}><div className='bg-btn-get-started'>{button}</div></Link>}
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-none d-sm-block">
                    <div className='bg-grad-purple text-center get-start-img'>
                        <img src={imagePath} alt="get-started-lurantech" />
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};
